import * as React from 'react'
import type { JSX } from 'react'

import { getEntriesWithKeys } from '~publish/helpers/getEntriesWithKeys'

import { useCalendarContext } from './context'
import { useScrollToCurrentHour } from './hooks/useScrollToCurrentHour'
import { Hour } from './Hour'
import type { CalendarBlockData } from './types'

type ThreeDayProps = {
  hours: CalendarBlockData[][]
  scrollContainerRef: React.RefObject<HTMLDivElement>
}

const ThreeDay = ({
  hours,
  scrollContainerRef,
}: ThreeDayProps): JSX.Element => {
  const { loading, currentTime, scrollTarget } = useCalendarContext()
  const currentHourRef = useScrollToCurrentHour(scrollContainerRef)
  const scrollHour = scrollTarget ?? currentTime.now

  return (
    <>
      {getEntriesWithKeys(hours, (hourRow) =>
        hourRow.map((hour) => hour.start.toString()).join('|'),
      ).map(({ key, item: hourRow }, columnIndex) => (
        <tr
          key={key}
          data-testid={`three-day-row-${hourRow[0]?.start.toString()}`}
        >
          {hourRow.map((hour, index) => {
            const isScrollHour =
              hour.start.hour === scrollHour?.hour &&
              hour.start.day === scrollHour?.day &&
              hour.start.month === scrollHour?.month &&
              hour.start.year === scrollHour?.year
            return (
              <Hour
                key={hour.start.toString()}
                index={columnIndex}
                loading={loading}
                hour={hour}
                showLabel={index === 0}
                ref={isScrollHour ? currentHourRef : null}
              />
            )
          })}
        </tr>
      ))}
    </>
  )
}

const memoThreeDay = React.memo(ThreeDay)
export { memoThreeDay as ThreeDay }
